import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 48 48\" id=\"search\">\n  <path d=\"M30.344 27.516a13.537 13.537 0 1 0-2.828 2.828l11.07 11.07 2.828-2.828ZM19.5 29a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol